import { MODEL_PREVIEW_APP_BASE } from "./model-preview-app.const";
import {
  AlertCircleIcon,
  File02Icon,
  HomeSmileIcon,
  Users01Icon,
  Monitor01Icon,
  User01Icon,
  BarChart10Icon,
  Inbox01Icon,
  Mail01Icon,
  MessageTextSquare01Icon,
  Settings02Icon,
  BookClosedIcon,
  Announcement01Icon,
  ClipboardIcon,
  PlusSquareIcon,
  Brush03Icon,
  ContainerIcon,
  ClockRewindIcon,
  ListIcon,
  FolderIcon,
  Globe04Icon,
} from "@vetty/icons";

export type SidebarNavSubItemConfig = {
  href: string;
  icon: React.ReactNode;
  label: string;
  /** When true, sub-item is active only on exact href (avoids `/models` matching `/models/upload`). */
  exactActive?: boolean;
  /** Open in new tab (e.g. model-preview app for local file testing). */
  external?: boolean;
};

export type SidebarNavItemConfig = {
  href: string;
  icon: React.ReactNode;
  label: string;
  subItems?: SidebarNavSubItemConfig[];
  action?: "open-report-problem-modal";
  /**
   * Paths that share this item’s prefix but belong to another nav route (e.g. `/models/review`
   * under Library’s `/models`).
   */
  excludeActivePathPrefixes?: string[];
};

export type SidebarNavGroupConfig = {
  group: string;
  collapsible?: boolean;
  defaultOpen?: boolean;
  items: SidebarNavItemConfig[];
};

const SIDEBAR_NAV_ITEMS: SidebarNavGroupConfig[] = [
  {
    group: "General",
    items: [
      {
        href: "/overview",
        icon: <HomeSmileIcon style={{ width: 20, height: 20 }} />,
        label: "Overview",
      },
      {
        href: "/statistics",
        icon: <BarChart10Icon style={{ width: 20, height: 20 }} />,
        label: "Statistics",
      },
      {
        href: "/inbox",
        icon: <Inbox01Icon style={{ width: 20, height: 20 }} />,
        label: "Inbox",
        subItems: [
          {
            href: "/inbox/forms",
            icon: <File02Icon style={{ width: 20, height: 20 }} />,
            label: "Forms",
          },
          {
            href: "/inbox/email",
            icon: <Mail01Icon style={{ width: 20, height: 20 }} />,
            label: "E-mail",
          },
          {
            href: "/inbox/chat",
            icon: <MessageTextSquare01Icon style={{ width: 20, height: 20 }} />,
            label: "Chat",
          },
        ],
      },
      {
        href: "/issues",
        icon: <AlertCircleIcon style={{ width: 20, height: 20 }} />,
        label: "Issues",
      },
    ],
  },
  {
    group: "Clients",
    items: [
      {
        href: "/accounts",
        icon: <User01Icon style={{ width: 20, height: 20 }} />,
        label: "Accounts",
      },
      {
        href: "/groups",
        icon: <Users01Icon style={{ width: 20, height: 20 }} />,
        label: "Groups",
      },
      {
        href: "/devices",
        icon: <Monitor01Icon style={{ width: 20, height: 20 }} />,
        label: "Devices",
        subItems: [
          {
            href: "/devices/enroll",
            icon: <PlusSquareIcon style={{ width: 20, height: 20 }} />,
            label: "Enroll",
          },
          {
            href: "/devices/profiles",
            icon: <ClipboardIcon style={{ width: 20, height: 20 }} />,
            label: "Profiles",
          },
          {
            href: "/devices/branding",
            icon: <Brush03Icon style={{ width: 20, height: 20 }} />,
            label: "Branding",
          },
        ],
      },
    ],
  },
  // {
  //   group: "Payments",
  //   items: [
  //     { href: "/balance", icon: <NavBalanceIcon />, label: "Balance" },
  //     { href: "/products", icon: <NavProductsIcon />, label: "Products" },
  //   ],
  // },
  {
    group: "Content",
    items: [
      {
        href: "/models",
        icon: <ContainerIcon style={{ width: 20, height: 20 }} />,
        label: "Models",
        subItems: [
          {
            href: "/models/review",
            icon: <Inbox01Icon style={{ width: 20, height: 20 }} />,
            label: "Review",
          },
          {
            href: "/models/history",
            icon: <ClockRewindIcon style={{ width: 20, height: 20 }} />,
            label: "History",
          },
          {
            href: `${MODEL_PREVIEW_APP_BASE}/local`,
            icon: <Globe04Icon style={{ width: 20, height: 20 }} />,
            label: "Preview",
            external: true,
          },
        ],
      },
      {
        href: "/changelog",
        icon: <ListIcon style={{ width: 20, height: 20 }} />,
        label: "Changelog",
      },
      {
        href: "/content/assets",
        icon: <FolderIcon style={{ width: 20, height: 20 }} />,
        label: "Assets",
      },
    ],
  },
  {
    group: "Others",
    items: [
      {
        href: "/report-problem",
        icon: <Announcement01Icon style={{ width: 20, height: 20 }} />,
        label: "Report a problem",
        action: "open-report-problem-modal",
      },
      {
        href: "/docs",
        icon: <BookClosedIcon style={{ width: 20, height: 20 }} />,
        label: "Documentations",
      },
      {
        href: "/settings",
        icon: <Settings02Icon style={{ width: 20, height: 20 }} />,
        label: "Settings",
      },
    ],
  },
];

export { SIDEBAR_NAV_ITEMS };
